export const EXPERIENCE_PLAYER_BASE_URL =
  process.env.EXPERIENCE_PLAYER_BASE_URL ||
  `https://eplayer${process.env.SUBDOMAIN ?? '-np-dev'}.${process.env.HOST_DOMAIN ?? 'cfctest.org'}`

export const LOCAL_STORAGE_KEY = 'experiencePlayer_link'

export const POLL_INTERVAL_MS = 30000

export const DEFAULT_TTL_SECONDS = 86400
